export const ArrowDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 120 80" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M5 20 C 30 10, 55 55, 90 40"
    />
    <path className="doodle" d="M80 30 L92 42 L78 50" />
  </svg>
);

export const StarDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M20 4 L24 16 L36 18 L27 26 L30 38 L20 31 L10 38 L13 26 L4 18 L16 16 Z"
    />
  </svg>
);

export const CircleDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 120 60" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M10 30 C 10 5, 110 5, 110 30 C 110 55, 10 55, 10 30 Z"
    />
  </svg>
);

export const UnderlineDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 200 20" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M2 12 C 40 4, 90 18, 140 8 C 170 2, 190 10, 198 6"
    />
  </svg>
);

export const HeartDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M20 34 C 6 24, 4 12, 12 8 C 17 6, 20 10, 20 14 C 20 10, 23 6, 28 8 C 36 12, 34 24, 20 34 Z"
    />
  </svg>
);

export const ScribbleDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 80 40" className={className} aria-hidden="true">
    <path
      className="doodle"
      d="M4 30 C 12 10, 20 30, 28 12 C 36 30, 44 10, 52 28 C 60 12, 68 30, 76 14"
    />
  </svg>
);
